/***
 * model representing a connection or friend.
 */
import Backbone from 'backbone';

var UserConnection = Backbone.Model.extend({
    initialize: function(args) {}
});

export default UserConnection;
